import React from 'react'
import {
    Button,
    Box,
    Text,
    Flex,
    useTheme
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
import {CloseIcon} from '@salesforce/retail-react-app/app/components/icons'

const LoyaltyCoupon = ({
    isPointsApplied,
    availablePoints,
    numberOfRedeemedPoints,
    discount,
    reedemPoints,
    removePoints,
    isPaymentStep = false
}) => {
    const theme = useTheme()
    return (
        <Box {...theme.components.Loyalty.container} mt={isPaymentStep ? 4 : 0} mb={isPaymentStep ? 4 : 0}>
            <Text {...theme.components.Loyalty.title}>
                <FormattedMessage
                    defaultMessage="Redeem Your Garage Collectif Points"
                    id="cart.loyalty.coupon.title"
                />
            </Text>
            {!isPointsApplied && (
                <Text fontSize="sm">
                    <FormattedMessage
                        defaultMessage="Available points: {availablePoints}"
                        values={{
                            availablePoints: (
                                <Text as="span" data-private>
                                    {availablePoints}
                                </Text>
                            )
                        }}
                        id="cart.loyalty.coupon.available_point"
                    />
                </Text>
            )}
            <Flex justifyContent="space-between" alignItems="center" mt="2">
                <Text fontSize="sm" {...(isPointsApplied && {fontWeight: '600'})}>
                    <FormattedMessage
                        defaultMessage="{discount} off ({numberOfRedeemedPoints} pts)"
                        values={{
                            discount: (
                                <Text as="span" data-private>
                                    {discount}
                                </Text>
                            ),
                            numberOfRedeemedPoints: (
                                <Text as="span" data-private>
                                    {numberOfRedeemedPoints}
                                </Text>
                            )
                        }}
                        id="cart.loyalty.coupon.dicount"
                    />
                </Text>
                {isPointsApplied ? (
                    <Button variant="link" onClick={removePoints}>
                        <CloseIcon />
                    </Button>
                ) : (
                    <Button
                        variant="outline"
                        {...theme.components.Loyalty.button}
                        onClick={reedemPoints}
                    >
                        <FormattedMessage
                            defaultMessage="Apply"
                            id="promo_code_fields.button.apply"
                        />
                    </Button>
                )}
            </Flex>
            {isPointsApplied && (
                <Text fontSize="xs">
                    <FormattedMessage
                        defaultMessage="Applied"
                        id="cart.loyalty.coupon.dicount.applied_text"
                    />
                </Text>
            )}
        </Box>
    )
}

LoyaltyCoupon.propTypes = {
    isPointsApplied: PropTypes.bool,
    availablePoints: PropTypes.number,
    numberOfRedeemedPoints: PropTypes.number,
    discount: PropTypes.string,
    reedemPoints: PropTypes.func,
    removePoints: PropTypes.func,
    isPaymentStep: PropTypes.bool
}

export default LoyaltyCoupon
